import {scorePill} from '../layouts/theme/designSystem';

export const SCORE_LEVEL_HIGH_THRESHOLD = 80;
export const SCORE_LEVEL_MEDIUM_THRESHOLD = 60;

export type ScoreLevel = 'high' | 'medium' | 'low';

export type ScoreLevelColors = {
  strokeColor: string;
  bgcolor: string;
  color: string;
};

export const getScoreLevel = (score: number): ScoreLevel => {
  if (score >= SCORE_LEVEL_HIGH_THRESHOLD) {
    return 'high';
  }
  if (score >= SCORE_LEVEL_MEDIUM_THRESHOLD) {
    return 'medium';
  }
  return 'low';
};

export const getScoreLevelColors = (score: number): ScoreLevelColors => {
  const {bgcolor, color, strokeColor} = scorePill[getScoreLevel(score)];

  return {
    strokeColor,
    bgcolor,
    color,
  };
};

/** Shared sx for borderless score pill chips (TableRowScorePill, heatmap cells, etc.) */
export const scorePillChipSx = {
  border: 'none',
  boxShadow: 'none',
} as const;
